module.exports = __webpack_public_path__ + "static/20-7efce12c88a20e0b706488c75ee24d55.jpg";